'use client';

import React from 'react';
import { SwiperSlide } from 'swiper/react';
import SliderWrapper from '../Wrapper/SliderWrapper';
import HomePageCategorySkeleton from '../Skeleton/HomePageCategorySkeleton';
import CategoryCard from '../Card/CategoryCard';

// slider classes
import 'swiper/css';
import 'swiper/css/scrollbar';
import './custom_scrollbar.css';
import 'swiper/css/mousewheel';

function WhatAreYouLookingSlider({ data, isLoading = false }) {
  let content;

  if (isLoading) {
    content = (
      <SwiperSlide className="!w-max !flex !justify-center xl:!justify-start">
        <HomePageCategorySkeleton />
      </SwiperSlide>
    );
  } else if (Array.isArray(data) && data.length > 0) {
    content = data.map((category, index) => {
      if (!category?.name?.en) return null;

      return (
        <SwiperSlide
          key={category?.id ?? index}
          className="!w-max !flex !justify-center xl:!justify-start"
        >
          <CategoryCard category={category} key={category?.slug} />
        </SwiperSlide>
      );
    });
  } else {
    content = null;
  }

  return <SliderWrapper data={data}>{content}</SliderWrapper>;
}

export default WhatAreYouLookingSlider;
